import { surnameListApi } from "../../api/surname/surnameListApi"
import { Surname } from "../../entities/surname"

type PayloadShape = Parameters<typeof surnameListApi>[0]

export async function surnameListService(payload: PayloadShape, token?: null | string) {
	const surname = await surnameListApi(payload, token)
	return surname as NonNullable<Surname[]>
}
